// Russia-side filter chip. Visual parity with the china
// `RequestsFilterChip` (same dimensions, tokens, `aria-pressed`) but
// kept local so the russia-requests feature does not deep-import a
// china component just for a small primitive — the file is small and
// the cross-feature dependency would complicate isolated tests.
export function RussiaRequestsFilterChip(props: {
  chipId: string;
  label: string;
  count: number | undefined;
  active: boolean;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      data-testid={`russia-requests-chip-${props.chipId}`}
      onClick={props.onClick}
      aria-pressed={props.active}
      style={{
        height: 26,
        padding: '0 10px',
        borderRadius: 'var(--r-1)',
        fontSize: 12,
        fontWeight: 500,
        border: '1px solid',
        borderColor: props.active ? 'transparent' : 'var(--border-1)',
        background: props.active ? 'var(--accent-1-subtle)' : 'var(--bg-1)',
        color: props.active ? 'var(--accent-1-press)' : 'var(--fg-2)',
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        cursor: 'pointer',
      }}
    >
      <span>{props.label}</span>
      {props.count !== undefined && (
        <span
          style={{
            fontFamily: 'var(--font-mono)',
            fontSize: 10,
            color: props.active ? 'var(--accent-1-press)' : 'var(--fg-3)',
          }}
        >
          {props.count}
        </span>
      )}
    </button>
  );
}
